<div class="row">
    <div [formGroup]="parentForm" id="radio-control-container">
        <mm-control-label [controlName]="controlName" [label]="title" [hasError]="hasError"
            id="delivery-method-control-label">
        </mm-control-label>
        <div class="radio-container">
            <input [attr.disabled]="isFromEditSubmittedTransaction || null" type="radio" formControlName="{{controlName}}" 
                value="standard" id="{{controlName + '-standard'}}"
                attr.data-testid="{{controlName + '-standard-input'}}">
            <label for="{{controlName + '-standard'}}">
                <div attr.data-testid="{{controlName + '-standard-label'}}" class="radio-label">Standard mail</div>
            </label>
        </div>
        <div class="radio-container">
            <input [attr.disabled]="isInternational || isFromEditSubmittedTransaction || null" type="radio" 
                formControlName="{{controlName}}" value="overnight" id="{{controlName + '-overnight'}}"
                attr.data-testid="{{controlName + '-overnight-input'}}">
            <label for="{{controlName + '-overnight'}}">
                <div attr.data-testid="{{controlName + '-overnight-label'}}" class="radio-label">Overnight (next
                    business
                    day)</div>
            </label>
            <mm-tooltip data-testid="overnightTooltip" [position]="'right'" [containsLink]="false">
                <tooltip-content>
                    <div data-testid="tooltipText">{{overnightCheckCopy}}</div>
                </tooltip-content>
                <tooltip-trigger-element>
                    <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
                </tooltip-trigger-element>
            </mm-tooltip>
        </div>
        <span *ngIf="hasError" class="error-text">{{errorText}}</span>
    </div>
    <div id="fee-detail">
        <div id="checkInputPage_checkFeeLabel" data-testid="feeLabel" class="fee-label">Fee</div>
        <div id="checkInputPage_checkStandardDelivery" data-testid="standardPrice">Free</div>
        <div id="checkInputPage_checkStandardOvernight" data-testid="overnightPrice">{{ checkFee$ | async | currency }}
        </div>
    </div>
</div>
<mm-banners *ngIf="showThirdAddresseeInfoBanner" data-testid="thirdAddresseeNameInfoBanner" [type]="'information'"
    [bannerText]="[thirdAddresseeNameText]"></mm-banners>
<mm-banners *ngIf="showOvernightCheckBanner" data-testid="overnightCheckBanner" [type]="'error'"
    [bannerText]="[overnightCheckBanner]"></mm-banners>